module.exports = __webpack_public_path__ + "img/phase2.a762b7e7.png";